import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { ManualPermission } from 'types/permissions_response';
import { Group } from 'views/App/Portal/LexID/Groups/_types/group';

export type GroupManualsResponse = {
  manuals: ManualPermission[];
};

export default function useGroupManuals(
  organizationId: string,
  groupId: string,
  params = {},
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  return useQuery<GroupManualsResponse, ServerErrorResponse>(
    ['group_manual_permissions', organizationId, groupId, params],
    async ({ signal }): Promise<GroupManualsResponse> => {
      try {
        const group: Group = await fetcher({
          url: `${baseApiUrl()}/lexid/user-group/v1/organizations/${organizationId}/groups/${groupId}`,
        });

        const url = `${baseApiUrl()}/lexid/admin-manual-authorization/v1/organizations/${organizationId}/roles/${group.childRoleId}/manual-permissions`;
        const data: GroupManualsResponse = await fetcher({
          method: 'get',
          url,
          options: { signal },
        });

        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      keepPreviousData: true,
      ...options,
    }
  );
}
